module.exports = __webpack_public_path__ + "static/media/equantia_map.adaca1e7.png";